// extracted by mini-css-extract-plugin
export default {"linkButtonContainer":"Account_linkButtonContainer__u5-Lg","linkButton":"Account_linkButton__75T-I","linkButtonWrapper":"Account_linkButtonWrapper__YZ0Wd"};